var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-flex-col tw-p-6",attrs:{"id":"room-sidePanel"}},[_c('room-chat',{attrs:{"tEvent":_vm.tEvent,"live_room_participants":_vm.live_room_participants,"livekit_local_participant":_vm.livekit_local_participant}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }